import { styled } from '@mui/material/styles';
import { type Header } from '@tanstack/react-table';
import { memo } from 'react';
import type { DataSchema, Schema } from 'types';

const Resizer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isResizing',
})<{ isResizing: boolean }>(({ theme, isResizing }) => ({
  position: 'absolute',
  right: 0,
  top: 0,
  height: '100%',
  width: '4px',
  cursor: 'col-resize',
  userSelect: 'none',
  touchAction: 'none',
  zIndex: 1,
  opacity: isResizing ? 1 : 0,
  backgroundColor: isResizing ? theme.palette.grey[400] : theme.palette.grey[200],
  transition: 'opacity 0.2s',
}));

const ResizerButtonBase = <T extends keyof P, P extends DataSchema>({
  header,
  onResizeStart,
}: {
  header: Header<Schema<T, P>, unknown>;
  onResizeStart?: (columnId: string) => void;
}) => {
  return (
    <Resizer
      className="resizer"
      isResizing={header.column.getIsResizing()}
      onMouseDown={(event) => {
        onResizeStart?.(header.column.id);
        header.getResizeHandler()(event);
      }}
      onTouchStart={(event) => {
        onResizeStart?.(header.column.id);
        header.getResizeHandler()(event);
      }}
      onClick={(e) => e.stopPropagation()}
    />
  );
};

export const ResizerButton = memo(ResizerButtonBase) as unknown as typeof ResizerButtonBase;
